import { isEmpty, isEqual } from "lodash";
import { postUserLog } from "../../actions/common";

export const postLogForFilter = (
  gridRef,
  gridEvent,
  siteUId,
  tierId,
  boxName,
  boxNumber,
  rpsId,
  navigationOn
) => {
  const { name, fullName, value } = gridEvent;

  if (
    name === "columns" &&
    !isEmpty(value) &&
    ["filterType", "filterValue", "filterValues"].includes(
      fullName.split(".")[1]
    )
  ) {
    const visibleColumns = gridRef.current.instance.getVisibleColumns();

    const colName = visibleColumns.filter((col) =>
      isEqual(col.filterValues ? col.filterValues : col.filterValue, value)
    )[0]?.dataField;

    if (!isEmpty(colName)) {
      postUserLog({
        event: `Box ${boxNumber} - ${boxName} Filter`,
        data: {
          action: `${colName} filtered/searched for PS-${rpsId}`,
          module: "Digital Tier",
          section: navigationOn,
          siteUId,
          widget: "Structured Problem Solving",
          tierId,
        },
      });
    }
  }

  /* KEPT THIS FOR ONE MORE LOG - COLUMN CHOOSER - WIP*/
  // if (
  //   name === "columns" &&
  //   !isEmpty(value) &&
  //   ["visible"].includes(fullName.split(".")[1])
  // ) {
  //   const currentVisibleColumns = gridRef.current.instance.getVisibleColumns();
  //   const regex = /\[(\d+)\]/;
  //   const columnIndex = fullName.match(regex);
  // }
};
